// simple sorting is done like that, but is not sufficient:
// json.locations.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
// because you may want to have your own specific order 
// sorting with predefined order:
export const sortLocations = (locations, namesOrder) => {
    let sorted = [];
    namesOrder.forEach(name => {
        const oldIndex = locations.findIndex(location => location.name == name);
        if (oldIndex > -1) {
            sorted.push(locations[oldIndex]);
            locations.splice(oldIndex, 1);
        }
    });
    sorted.push(...locations);
    return sorted;
};
